export default {
    apiKey: 'AIzaSyCJTdkiOl1JTCJwt1lUf6qFPeCW3XOf8MI',
    authDomain: 'cald-9d4ed.firebaseapp.com',
    projectId: 'cald-9d4ed',
    storageBucket: 'cald-9d4ed.appspot.com',
    messagingSenderId: '310045970657',
    appId: '1:310045970657:web:5a3e499c9fd941fe5de7a0',
    measurementId: 'G-LKS5QJ7ZNR'
}
